import { render, staticRenderFns } from "./MenuActions.vue?vue&type=template&id=05087f7f&scoped=true&"
import script from "./MenuActions.vue?vue&type=script&lang=js&"
export * from "./MenuActions.vue?vue&type=script&lang=js&"
import style0 from "./MenuActions.vue?vue&type=style&index=0&id=05087f7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05087f7f",
  null
  
)

export default component.exports